// https://stackoverflow.com/a/8260383/11486560
export function getYouTubeVideoId(url: string) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/|shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = regExp.exec(url);
  return match && match[7].length === 11 ? match[7] : false;
}
